import React from 'react';

interface ServiceCardProps {
  title: string;
  description: string;
  image: string;
}

const ServiceCard: React.FC<ServiceCardProps> = ({ title, description, image }) => {
  return (
    <div className="bg-black shadow-lg rounded-lg overflow-hidden transform transition-all duration-300 hover:scale-105">
      <div className="h-48 overflow-hidden">
        <img 
          src={image} 
          alt={title} 
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6">
        <h3 className="text-gold text-xl font-bold mb-2">{title}</h3>
        <p className="text-white">{description}</p>
      </div>
    </div>
  );
};

export default ServiceCard;